import { render } from "./CounselingReportDetails.vue?vue&type=template&id=aebfba78&ts=true"
import script from "./CounselingReportDetails.vue?vue&type=script&lang=ts"
export * from "./CounselingReportDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__